import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";

const SignaturePadComponent = forwardRef((props, ref) => {
  
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);

  useImperativeHandle(ref, () => ({
    getImage: () => canvasRef.current.toDataURL("image/png"), // Retorna base64
    clear: () => clearCanvas(),
  }));

  const startDrawing = (eventOrCoords) => {
    setDrawing(true);
    const ctx = canvasRef.current.getContext("2d");

    let x, y;

    if (eventOrCoords?.x !== undefined) {
      // Touch
      x = eventOrCoords.x;
      y = eventOrCoords.y;
    } else {
      // Mouse
      x = eventOrCoords.nativeEvent.offsetX;
      y = eventOrCoords.nativeEvent.offsetY;
    }

    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.strokeStyle = "blue";
    ctx.lineWidth = 2;
  };

  const draw = (eventOrCoords) => {
    if (!drawing) return;
    const ctx = canvasRef.current.getContext("2d");

    let x, y;

    if (eventOrCoords?.x !== undefined) {
      x = eventOrCoords.x;
      y = eventOrCoords.y;
    } else {
      x = eventOrCoords.nativeEvent.offsetX;
      y = eventOrCoords.nativeEvent.offsetY;
    }

    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const stopDrawing = () => {
    setDrawing(false);
  };

  const clearCanvas = () => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
  };

  useEffect(() => {
    const canvas = canvasRef.current;

    const getTouchCoordinates = (event) => {
      const rect = canvas.getBoundingClientRect();
      const touch = event.touches[0];
      return {
        x: touch.clientX - rect.left,
        y: touch.clientY - rect.top,
      };
    };

    const handleTouchStart = (event) => {
      const coords = getTouchCoordinates(event);
      startDrawing(coords);
      event.preventDefault();
    };

    const handleTouchMove = (event) => {
      const coords = getTouchCoordinates(event);
      draw(coords);
      event.preventDefault();
    };

    const handleTouchEnd = () => {
      stopDrawing();
    };

    canvas.addEventListener("touchstart", handleTouchStart, { passive: false });
    canvas.addEventListener("touchmove", handleTouchMove, { passive: false });
    canvas.addEventListener("touchend", handleTouchEnd);

    return () => {
      canvas.removeEventListener("touchstart", handleTouchStart);
      canvas.removeEventListener("touchmove", handleTouchMove);
      canvas.removeEventListener("touchend", handleTouchEnd);
    };
  }, [drawing]);

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={460}
        height={150}
        style={{
          border: "1px solid #aaaaaa",
          touchAction: "none",
        }}
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={stopDrawing}
        onMouseLeave={stopDrawing}
      />
      <br />
      <button onClick={clearCanvas}>Limpiar PAD</button>
    </div>
  );
});

export default SignaturePadComponent;